const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const formatAmount = (amount) => {
  const amountNumber = Number(amount);
  if (Number.isNaN(amountNumber)) return "$0.00";
  return `$${amountNumber.toFixed(2)}`;
};

const toTitleCase = (value) => {
  if (!value) return "Active";
  const text = String(value);
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

const resolveCompanyName = (item) => {
  const directReferralClient = item?.referral_client;
  if (typeof directReferralClient === "string" && directReferralClient.trim()) {
    return directReferralClient;
  }
  if (directReferralClient && typeof directReferralClient === "object") {
    return (
      directReferralClient.client_name ||
      directReferralClient.name ||
      directReferralClient.company ||
      "N/A"
    );
  }

  const directClient = item?.client;
  if (typeof directClient === "string" && directClient.trim()) return directClient;
  if (directClient && typeof directClient === "object") {
    return directClient.client_name || directClient.name || directClient.company || "N/A";
  }

  return "N/A";
};

const resolveReferralEmail = (item) => {
  if (typeof item?.referral_client_email === "string" && item.referral_client_email.trim()) {
    return item.referral_client_email;
  }

  const referralClient = item?.referral_client;
  if (referralClient && typeof referralClient === "object") {
    if (typeof referralClient.client_email === "string" && referralClient.client_email.trim()) {
      return referralClient.client_email;
    }
    if (typeof referralClient.email === "string" && referralClient.email.trim()) {
      return referralClient.email;
    }
  }

  const client = item?.client;
  if (client && typeof client === "object") {
    if (typeof client.client_email === "string" && client.client_email.trim()) {
      return client.client_email;
    }
    if (typeof client.email === "string" && client.email.trim()) {
      return client.email;
    }
  }

  return "N/A";
};

const resolveReferralStatus = (item) => {
  // Flat referral object (e.g. client_status) or nested client objects.
  const direct = item?.referral_status || item?.client_status || item?.status;
  if (typeof direct === "string" && direct.trim()) return direct.trim();

  const referralClient = item?.referral_client;
  if (referralClient && typeof referralClient === "object") {
    const nested = referralClient.client_status || referralClient.status;
    if (typeof nested === "string" && nested.trim()) return nested.trim();
  }

  const client = item?.client;
  if (client && typeof client === "object") {
    const nested = client.client_status || client.status;
    if (typeof nested === "string" && nested.trim()) return nested.trim();
  }

  return item?.invoice_id ? "Active" : "Inactive";
};

export const mapReferral = (item) => ({
  company: resolveCompanyName(item),
  email: resolveReferralEmail(item),
  status: toTitleCase(resolveReferralStatus(item)),
  earnings: formatAmount(item?.referral_bonus),
  date: formatDate(item?.created_at),
});

export const toReferralStats = (statsPayload = {}) => [
  { label: "Total Clicks", value: statsPayload.totalClicks || "0" },
  { label: "Total Signups", value: statsPayload.totalSignups || "0" },
  { label: "Active Referrals", value: statsPayload.activeReferrals || "0" },
  { label: "Total Earnings", value: statsPayload.totalEarnings || "$0.00" },
];
